import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment/moment";

import { notify } from "@cayuse/shared-react.components.banner-notification";

import { updateLock } from "store/actions/form";
import { formSelectors } from "store/selectors";
import { useDictionary } from "hooks";

import { AlertDialog } from "@cayuse/shared-react.components.modal-dialog";

import { ACTIONS } from "../FormActions/constants";

const defaultDictionary = {
    title: "Do you want to continue editing?",
    message:
        "We noticed that you've been inactive. Your editing session will end in two (2) minutes unless you continue.",
    confirmButtonLabel: "Continue editing",
    inactivityMessage:
        "Your editing session ended due to inactivity. Changes you made were not saved.",
};

const interval = 10000;

export const FormTimeoutModal = ({ onAction }) => {
    const dictionary = useDictionary("common.timeoutModal");
    const { formTimeoutInfo } = useSelector(formSelectors.entity);
    const [showContinueDialog, setShowContinueDialog] = useState(false);

    useEffect(() => {
        if (formTimeoutInfo && formTimeoutInfo.showTimeoutWarningAt) {
            const intervalId = setInterval(() => {
                if (
                    moment().diff(formTimeoutInfo.releaseLockOnInactivityAt) > 0
                ) {
                    notify(
                        defaultDictionary.inactivityMessage ??
                            defaultDictionary.inactivityMessage,
                        { type: "warning", autoClose: false }
                    );
                    onAction(ACTIONS.CANCEL);
                    clearInterval(intervalId);
                } else if (
                    moment().diff(formTimeoutInfo.showTimeoutWarningAt) > 0
                ) {
                    setShowContinueDialog(true);
                }
            }, interval);
            return () => {
                clearInterval(intervalId);
            };
        }
    }, [formTimeoutInfo]);

    const contineEditing = async () => {
        await updateLock();
        setShowContinueDialog(false);
    };

    return (
        <AlertDialog
            title={dictionary.title ?? defaultDictionary.title}
            description={defaultDictionary.message ?? defaultDictionary.message}
            isOpen={showContinueDialog}
            onConfirm={contineEditing}
            confirmText={
                dictionary.confirmButtonLabel ??
                defaultDictionary.confirmButtonLabel
            }
            hideCancel={true}
        />
    );
};
